import { gql, useQuery } from "@apollo/client";

export const CreateBackofficeUser = gql`
	mutation CreateBackofficeUser(
		$name: String
		$phoneNumber: String
		$avatar: String
		$addressInfo: AddressInfoInput
		$localidade: String
		$email: String
		$password: String
	) {
		createBackofficeUser(
			input: {
				name: $name
				email: $email
				addressInfo: $addressInfo
				localidade: $localidade
				phoneNumber: $phoneNumber
				password: $password
				avatar: $avatar
			}
		) {
			_id
			name
			email
			dob
			createdAt
		}
	}
`;
